import React from 'react';
import {
    Card, CardHeader, CardBody,
    CardLink, CardText, Modal, ModalBody, ModalFooter, CardFooter,
    Button
} from 'reactstrap';


export default class CardTelefono extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            icon: "fa-phone",
            header: "Otro",
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    render() {

        if (this.props.tipo === "D") {
            return (
                <div className="col-md-3 col-xs-4" style={{ paddingBottom: "15px" }}>
                    <Card>
                        <CardHeader><i className="fas fa-phone" aria-hidden="true"></i> Domicilio</CardHeader>
                        <CardBody>
                            <CardText>+{this.props.codigo_pais} {this.props.codigo_area} {this.props.numero}</CardText>
                        </CardBody>
                        <CardFooter className="text-muted">
                            <div style={{ float: "left" }}>
                                {this.props.number}
                            </div>
                            <div style={{ float: "right" }}>
                                <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                                <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                            </div>
                        </CardFooter>
                    </Card>
                    <Modal isOpen={this.state.isOpen} fade={ false } toggle={this.toggle} >

                        <ModalBody>
                            ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                            <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                        </ModalFooter>

                    </Modal>
                </div>
            )
            //this.setState({ icon: "fa-phone", header: "Domicilio" });

        }
        else if (this.props.tipo === "T") {
            //this.setState({ icon: "fa-phone-rotary", header: "Trabajo" });
            return (
                <div className="col-md-3 col-xs-4" style={{ paddingBottom: "15px" }}>
                    <Card>
                        <CardHeader><i className="fas fa-phone-rotary" aria-hidden="true"></i> Trabajo</CardHeader>
                        <CardBody>
                            <CardText>+{this.props.codigo_pais} {this.props.codigo_area} {this.props.numero}</CardText>
                        </CardBody>
                        <CardFooter className="text-muted">
                            <div style={{ float: "left" }}>
                                {this.props.number}
                            </div>
                            <div style={{ float: "right" }}>
                                <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                                <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                            </div>
                        </CardFooter>
                    </Card>
                    <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                        <ModalBody>
                            ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                            <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                        </ModalFooter>

                    </Modal>
                </div>
            )
        }
        else if (this.props.tipo === "C") {
            //this.setState({ icon: "fa-mobile", header: "Celular" });
            return (
                <div className="col-md-3 col-xs-4" style={{ paddingBottom: "15px" }}>
                    <Card>
                        <CardHeader><i className="fas fa-mobile" aria-hidden="true"></i> Celular</CardHeader>
                        <CardBody>
                            <CardText>+{this.props.codigo_pais} {this.props.codigo_area} {this.props.numero}</CardText>
                        </CardBody>
                        <CardFooter className="text-muted">
                            <div style={{ float: "left" }}>
                                {this.props.number}
                            </div>
                            <div style={{ float: "right" }}>
                                <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                                <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                            </div>
                        </CardFooter>
                    </Card>
                    <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                        <ModalBody>
                            ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                            <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                        </ModalFooter>

                    </Modal>
                </div>
            )
        }
        else {
            return (
                <div className="col-md-3 col-xs-4" style={{ paddingBottom: "15px" }}>
                    <Card>
                        <CardHeader><i className={"fas " + this.state.icon} aria-hidden="true"></i> {this.state.header}</CardHeader>
                        <CardBody>
                            <CardText>+{this.props.codigo_pais} {this.props.codigo_area} {this.props.numero}</CardText>
                        </CardBody>
                        <CardFooter className="text-muted">
                            <div style={{ float: "left" }}>
                                {this.props.number}
                            </div>
                            <div style={{ float: "right" }}>
                                <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                                <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                            </div>
                        </CardFooter>
                    </Card>
                    <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                        <ModalBody>
                            ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                            <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                        </ModalFooter>

                    </Modal>
                </div>
            )
        }

        
    
    }
}